import { configureStore } from '@reduxjs/toolkit';
import offersReducer from './offersSlice';
import referencesReducer from './referencesSlice';
import excelReducer from './excelSlice';

export const store = configureStore({
    reducer: {
        offers: offersReducer,
        references: referencesReducer,
        excel: excelReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
